export default "__VITE_ASSET__C0luK3Kl__"